import React from 'react';
import { WebsiteDesignProps } from './types';
import { Cpu, Code, Database } from 'lucide-react';
import { Button } from "@/components/ui/button";

const StemAcademy: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "NextGen STEM";

    return (
        <div className="bg-[#0f172a] text-white min-h-screen font-sans">
            {/* Circuit Background */}
            <div className="fixed inset-0 pointer-events-none opacity-5">
                <svg width="100%" height="100%">
                    <pattern id="circuit" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
                        <path d="M10 10 h 80 v 80 h -80 Z" fill="none" stroke="currentColor" strokeWidth="1"/>
                        <circle cx="10" cy="10" r="2" fill="currentColor"/>
                        <circle cx="90" cy="90" r="2" fill="currentColor"/>
                        <path d="M10 10 L 50 50 L 90 90" stroke="currentColor" strokeWidth="0.5"/>
                    </pattern>
                    <rect width="100%" height="100%" fill="url(#circuit)"/>
                </svg>
            </div>

            <nav className="relative z-10 container mx-auto px-8 py-6 flex justify-between items-center border-b border-white/10">
                <div className="text-2xl font-bold tracking-tighter flex items-center gap-2">
                    <span className="text-cyan-400">&lt;</span>
                    {schoolName}
                    <span className="text-cyan-400">/&gt;</span>
                </div>
                <div className="flex gap-4">
                    <Button variant="outline" className="border-cyan-500 text-cyan-500 hover:bg-cyan-500/10 hover:text-cyan-400 text-xs font-mono uppercase">
                        Student Login
                    </Button>
                </div>
            </nav>

            <main className="relative z-10 container mx-auto px-8 py-20">
                <div className="flex flex-col items-start max-w-3xl">
                    <div className="inline-block border border-cyan-500/30 bg-cyan-500/10 text-cyan-400 px-4 py-2 font-mono text-xs rounded mb-6">
                        System.init(Learning_v2.0);
                    </div>
                    <h1 className="text-6xl md:text-8xl font-bold mb-8 leading-none tracking-tight">
                        Engineer <br/> The Future.
                    </h1>
                    <p className="text-xl text-slate-400 mb-10 max-w-xl leading-relaxed">
                        A specialized curriculum focused on Science, Technology, Engineering, and Mathematics. We build the innovators of tomorrow.
                    </p>
                    <div className="flex gap-4">
                        <Button className="bg-cyan-500 hover:bg-cyan-600 text-black font-bold h-12 px-8">
                            Apply Now
                        </Button>
                        <Button variant="ghost" className="text-cyan-400 hover:text-cyan-300 hover:bg-white/5 font-mono">
                            View Course Catalog
                        </Button>
                    </div>
                </div>

                <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-[#1e293b] p-6 rounded-lg border border-white/5 hover:border-cyan-500/50 transition-colors group">
                        <Code className="text-cyan-400 mb-4 group-hover:scale-110 transition-transform" size={32} />
                        <h3 className="text-xl font-bold mb-2">Computer Science</h3>
                        <p className="text-slate-400 text-sm">Algorithms, data structures, and software development cycles.</p>
                    </div>
                    <div className="bg-[#1e293b] p-6 rounded-lg border border-white/5 hover:border-cyan-500/50 transition-colors group">
                        <Cpu className="text-cyan-400 mb-4 group-hover:scale-110 transition-transform" size={32} />
                        <h3 className="text-xl font-bold mb-2">Robotics</h3>
                        <p className="text-slate-400 text-sm">Hardware engineering, sensor integration, and automation.</p>
                    </div>
                    <div className="bg-[#1e293b] p-6 rounded-lg border border-white/5 hover:border-cyan-500/50 transition-colors group">
                        <Database className="text-cyan-400 mb-4 group-hover:scale-110 transition-transform" size={32} />
                        <h3 className="text-xl font-bold mb-2">Data Science</h3>
                        <p className="text-slate-400 text-sm">Big data analytics, machine learning, and statistical modeling.</p>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default StemAcademy;
